/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-08-04 14:34:24
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-08-04 15:45:23
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/Components/Video/index.tsx
 */
import React from 'react';

import _Video from 'src/components/Modules/Video';
import ContentGroupHOC from '../HOC';
import DataHOC from 'src/constrains/DraggableModules/Components/HOC/DataProcessHOC';
import { compose } from 'redux';
import { get } from 'lodash';
import { errKeys, EnumModuleType } from 'src/constrains/DraggableModules/tools';

const Video = (props) => {
  const { staticData, handleOnStaticsChange, specificError, disabled } = props;
  const videoError =
    get(specificError, `${errKeys[EnumModuleType.Video].video}`, []) || [];
  return (
    <_Video
      data={staticData}
      error={{ videoError }}
      disabled={disabled}
      onChange={handleOnStaticsChange}
    />
  );
};
export default compose(DataHOC, ContentGroupHOC)(Video);
